import { createStore } from 'vuex';

import {
    alert
} from './alert.module';
import {
    authentication
} from './authentication.module';
import {
    users
} from './users.module';
import {
    lang
} from './lang.module';

import * as building from '@/_store/building.module.js'
import * as property from '@/_store/property.module.js'
import createPersistedState from "vuex-persistedstate";


// save our state (isPanel open or not) 

export const store = createStore({
    modules: {
        alert,
        authentication,
        users,
        lang,
        building,
        property
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage,
        
    })],
    state: {
        barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
        drawer: true,
        mini:false,
    },
    mutations: {
        SET_BAR_IMAGE(state, payload) {
            state.barImage = payload;
        },
        SET_DRAWER(state, payload) {
            state.drawer = payload;
        },
        SET_MINI(state, payload) {
            state.mini = payload;
        }
    },
    actions: {},
    getters: {}
});